import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import ProductSizeModal from "@/Modals/WebDataManagement/MasterData/ProductSizes/Modal";
import React from "react";
import { columns } from "./Columns";
import { productSizesMasterDataApi } from "@/apis/apis";

export default function ProductSizesPage() {
  return (
    <MasterDataBaseTable
      label="Size"
      apiURL={productSizesMasterDataApi}
      columns={columns()}
      ModalComponent={ProductSizeModal}
      importData={BASE_IMPORT_DATA.PRODUCT_SIZES}
      enableStatus={false}
      enableSortData={true}
      renderLocale={(value) => {
        return (
          <div className="flex items-center justify-center">
            <div className="w-8 h-5 flex items-center justify-center bg-black text-white rounded-[3px] text-[15px] leading-[15px] font-light text-center tabular-nums">
              {value}
            </div>
          </div>
        );
      }}
    />
  );
}
